<template>
  <div>
    <div class='flex flex-wrap flex-col sm:flex-row justify-between sm:items-center gap-4'>
      <div>
        <h2 class='text-jananavy-900 font-medium'><slot name='title' /></h2>
        <p class='font-light text-sm'><slot name='description' /></p>
      </div>
    </div>
    <LoadingLayout :isLoading='isLoading' class='mt-8' :slownessThreshold='0'>
      <ReportNoDataWarning :warn='!view'>
        <Line :data='view.line' :options='lineOptions' />
      </ReportNoDataWarning>
    </LoadingLayout>
  </div>
</template>

<script setup>

import { computed, reactive, watch } from 'vue';

import Chart from 'chart.js/auto';
import { Line } from 'vue-chartjs';

import LoadingLayout from '@/components/layouts/loading-layout.vue';

import ReportNoDataWarning from '@/components/report/report-no-data-warning.vue';

import { usePayloadRequest } from '@/kernel/api';

const request = usePayloadRequest('GET', '/organisation/platform-growth');

const props = defineProps({
  params: Object,
  dimension: String
});

const lineOptions = {
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    y: {
      ticks: {
          precision: 0
      }
    }
  },
  maintainAspectRatio: false
}

const isLoading = computed(() => {
  return request.isLoading() || request.getData() === null;
});

const view = computed(() => {
  const data = request.getData();
  
  if (!data?.length) {
    return null;
  }
  
  return {
    line: {
      labels: data.map(row => row.year),
      datasets: [{
        data: data.map(row => row.count)
      }]
    }
  }
});

const load = () => {
  if (!props.params) {
    return;
  }
  
  if (props.params.year.from.toString().length !== 4) {
    return;
  }
  
  if (props.params.year.to.toString().length !== 4) {
    return;
  }
  
  request.doRequest({
    params: {
      ...props.params,
      dimension: props.dimension
    }
  });
}

watch(() => props.params, () => {
  load();
});

load();

</script>